import { Action } from '@ngrx/store';

import { Config } from '../../services/config/models/config';
import { XenaGlobalConfig } from '../../services/config/models/xena-global-config';
import { UraniaConfig } from '../../services/config/models/urania-config';
import { NeoConfig } from '../../services/config/models/neo-config';

export const LOAD_CONFIG = '[GO-SUITE:CONFIG] LOAD_CONFIG';
export const LOAD_CONFIG_SUCCESS = '[GO-SUITE:CONFIG] LOAD_CONFIG_SUCCESS';
export const LOAD_CONFIG_ERROR = '[GO-SUITE:CONFIG] LOAD_CONFIG_ERROR';
export const SAVE_CONFIG = '[GO-SUITE:CONFIG] SAVE_CONFIG';
export const SAVE_AGENT_CONFIG = '[GO-SUITE:CONFIG] SAVE_AGENT_CONFIG';
export const SAVE_CONFIG_SUCCESS = '[GO-SUITE:CONFIG] SAVE_CONFIG_SUCCESS';
export const SAVE_CONFIG_ERROR = '[GO-SUITE:CONFIG] SAVE_CONFIG_ERROR';
export const SET_TEMP_CONFIG = '[GO-SUITE:CONFIG] SET_TEMP_CONFIG';
export const SET_TEMP_CONFIG_SUCCESS = '[GO-SUITE:CONFIG] SET_TEMP_CONFIG_SUCCESS';
export const SET_TEMP_CONFIG_ERROR = '[GO-SUITE:CONFIG] SET_TEMP_CONFIG_ERROR';
export const INIT_CONFIG_STATE = '[GO-SUITE:CONFIG] INIT_CONFIG_STATE';

export class LoadConfig implements Action {
	readonly type = LOAD_CONFIG;

	constructor(public scope: string) {}
}

export class LoadConfigSuccess implements Action {
	readonly type = LOAD_CONFIG_SUCCESS;

	constructor(public scope: string, public payload: Config|XenaGlobalConfig|UraniaConfig|NeoConfig, public revision: string) {}
}

export class LoadConfigError implements Action {
	readonly type = LOAD_CONFIG_ERROR;

	constructor(public scope: string, public payload: string = '') {}
}

export class SaveConfig implements Action {
	readonly type = SAVE_CONFIG;

	constructor(public scope: string, public payload: Config|XenaGlobalConfig|UraniaConfig|NeoConfig, public patch: boolean = false) {}
}

export class SaveAgentConfig implements Action {
	readonly type = SAVE_AGENT_CONFIG;

	constructor(public scope: string, public payload: Partial<Config|XenaGlobalConfig|UraniaConfig|NeoConfig>, public patch: boolean = false) {}
}

export class SaveConfigSuccess implements Action {
	readonly type = SAVE_CONFIG_SUCCESS;

	constructor(public scope: string, public payload: Partial<Config | XenaGlobalConfig | UraniaConfig | NeoConfig>, public revision: string, public patch: boolean = false) {}
}

export class SaveConfigError implements Action {
	readonly type = SAVE_CONFIG_ERROR;

	constructor(public scope: string, public payload: string = '') {}
}

export class SetTempConfig implements Action {
	readonly type = SET_TEMP_CONFIG;

	constructor(public scope: string, public payload: Config|XenaGlobalConfig|UraniaConfig|NeoConfig) {}
}

export class SetTempConfigSuccess implements Action {
	readonly type = SET_TEMP_CONFIG_SUCCESS;

	constructor(public scope: string, public payload: Config|XenaGlobalConfig|UraniaConfig|NeoConfig) {}
}

export class SetTempConfigError implements Action {
	readonly type = SET_TEMP_CONFIG_ERROR;

	constructor(public scope: string, public payload: string = '') {}
}

export class InitConfigState implements Action {
	readonly type = INIT_CONFIG_STATE;

	constructor(public scope: string, public payload: Config|XenaGlobalConfig|UraniaConfig|NeoConfig, public revision: string) {}
}

export type All
	= LoadConfig
	| LoadConfigSuccess
	| LoadConfigError
	| SaveConfig
	| SaveConfigSuccess
	| SaveConfigError
	| SetTempConfig
	| SetTempConfigSuccess
	| SetTempConfigError
	| InitConfigState;



// WEBPACK FOOTER //
// ./src/app/shared/state-management/actions/config.ts